import { defineMessages } from 'react-intl'

export default defineMessages({
  addAdministrator: {
    id: 'OrganizationSettings.UserSearch.Label',
    defaultMessage: 'Add an Administrator'
  },
  addingRole: {
    id: 'OrganizationSettings.AddingOrganizationAdminRole',
    defaultMessage: 'Adding organization administrator role to user'
  },
  confirmRemove: {
    id: 'OrganizationSettings.ConfirmRemove',
    defaultMessage: 'Really want to remove?'
  },
  confirmOrganizationAdminRemove: {
    id: 'OrganizationSettings.ConfirmRemoveSubMessage',
    defaultMessage: 'This user be will be removed from the organization admin role'
  },
  email: {
    id: 'Email',
    defaultMessage: 'Email'
  },
  name: {
    id: 'Name',
    defaultMessage: 'Name'
  },
  noAdmins: {
    id: 'OrganizationSettings.NoOrganizationAdmins',
    defaultMessage: 'Currently there are no administrators for this organization'
  },
  removingRole: {
    id: 'OrganizationSettings.RemovingOrganizationAdminRole',
    defaultMessage: 'Removing organization administrator role from user'
  },
  searchPlaceholder: {
    id: 'OrganizationSettings.UserSearch.Placeholder',
    defaultMessage: 'Employee Name'
  },
  organizationAdministrators: {
    id: 'OrganizationSettings.OrganizationAdministrators',
    defaultMessage: 'Organization Administrators'
  },
  users: {
    id: 'users',
    defaultMessage: 'users'
  }
})
